import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-prompt-message',
    templateUrl: './prompt-message.component.html',
    styleUrls: ['./prompt-message.component.scss'],
    standalone: false
})
export class PromptMessageComponent implements OnInit {
  @Input() showForm: boolean;
  @Input() color: string; // Success, Primary or Danger...
  @Input() message: string;
  @Output() onClose = new EventEmitter();
  formattedMessage = '';
  constructor(public globalService: GlobalService) {}

  ngOnInit(): void {
this.formattedMessage = this.message.replace(/\\n/g, '<br>');
  }

  Close() {
    this.showForm = false;
    this.onClose.emit();
  }
}
